import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './Edit';
import Save from './save';

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	styles: [
		{ name: 'underline', label: 'Underline', isDefault: true },
		{ name: 'pills', label: 'Pills' },
		{ name: 'boxed', label: 'Boxed' },
	],
	icon: {
		foreground: '#0061FE',
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="24"
				height="24"
			>
				<path d="M2 5.5C2 4.7 2.7 4 3.5 4h17c.8 0 1.5.7 1.5 1.5v13c0 .8-.7 1.5-1.5 1.5h-17C2.7 20 2 19.3 2 18.5v-13Zm1.5 0v13h17v-13h-17Z" />
				<rect x="3" y="4" width="6" height="3" rx=".5" />
				<rect
					x="10"
					y="4"
					width="5"
					height="3"
					rx=".5"
					opacity=".3"
				/>
				<rect
					x="16"
					y="4"
					width="5"
					height="3"
					rx=".5"
					opacity=".3"
				/>
			</svg>
		),
	},
} );
